const makeInitialState = values => {
  return {
    phone: values.phone || ''
  };
};

export default makeInitialState;
